import {SchemaFiltroMensajeType} from "../../pages/messages/Messages";
import {MensajesRequestFields} from "../../pages/messages/api/schemas";
import {dateFormatter} from "../formatters";

class FilterStorage {
  keyStorage = 'filterStorage'

  public save(filterValues: SchemaFiltroMensajeType) {
    localStorage.setItem(this.keyStorage, JSON.stringify(filterValues))
  }

  public load(): SchemaFiltroMensajeType | null {
    const storedValues = localStorage.getItem(this.keyStorage);

    if (!storedValues) {
      return null;
    }

    try {
      const parsedValues = JSON.parse(storedValues) as SchemaFiltroMensajeType;

      parsedValues[MensajesRequestFields.FechaDesde] = dateFormatter.stringToDate(parsedValues[MensajesRequestFields.FechaDesde] || null);
      parsedValues[MensajesRequestFields.FechaHasta] = dateFormatter.stringToDate(parsedValues[MensajesRequestFields.FechaHasta] || null);

      return parsedValues;
    } catch (error) {
      console.error('Error parseando filtros:', error);
      this.clear();

      return null;
    }
  }

  public clear() {
    localStorage.removeItem(this.keyStorage)
  }
}

export const filterStorage = new FilterStorage()